import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import clsx from 'clsx';
import { Button, Card, CardContent, MenuItem, Select, TextField } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import "../Styles/react-datepicker.css";
import Moment from 'moment'
import Loader from 'react-loader-spinner';
import { withStyles } from '@material-ui/core/styles';
import ChipInput from 'material-ui-chip-input';
import Tooltip from '@material-ui/core/Tooltip';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import EventIcon from '@material-ui/icons/Event';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.dullGray,
        color: theme.palette.white,
        boxShadow: theme.shadows[1],
        fontSize: '13px',
    },
    arrow: {
        color: theme.palette.dullGray,
    }
}))(Tooltip);
const fields = [
    {
        name: 'name',
        label: 'Name',
        required: true,
    },
    {
        name: 'phone',
        label: 'Phone Number',
        required: true,
    }
]
const maxTime = 7
@inject('commonStore') @observer
@observer
class Confirmation extends Component {
    state = {
        info: {},
        validationErrors: {},
        inProgress: false,
        emailIds: [],
        selectedDate: '',
        duration: ''
    }

    validateFields = () => {
        const { validationErrors, info, emailIds } = this.state;


        let valid = true
        fields.map((row) => {
            if (row.required && !info[`${row.name}`] || (info[`${row.name}`] && !info[`${row.name}`].replace(/\s/g, '').length)) {
                validationErrors[`${row.name}`] = 'Please enter a valid ' + row.label.toLowerCase()
                this.setState({ validationErrors });
                valid = false;
            }
            else if (row.name === 'phone' && !this.props.commonStore.validatePhone(info.phone)) {
                validationErrors[`${row.name}`] = 'Please enter a valid phone number'
                this.setState({ validationErrors });
                valid = false;
            }
            else
                delete validationErrors[`${row.name}`]
        })
        if (!info.emailId || !this.props.commonStore.validateEmail(info.emailId)) {
            validationErrors.emailId = 'Please enter a valid Email ID'
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors.emailId
        if (emailIds && emailIds.length) {
            emailIds.map((row) => {
                if (!this.props.commonStore.validateEmail(row)) {
                    validationErrors.emailIds = 'Please ensure all email addresses are properly formatted.'
                    this.setState({ validationErrors });
                    valid = false
                }
                else {
                    delete validationErrors.emailIds
                }

            })
        }
        else {
            delete validationErrors.emailIds
        }

        if (valid) {
            this.setState({
                validationErrors: {}
            });
        }
        return valid;
    }

    bookSlot = () => {
        let valid = false
        valid = this.validateFields()
        if (valid) {
            this.setState({ inProgress: true })
            let temp = new Date(this.props.selectedDate).setMinutes(0)
            this.props.commonStore.bookSlot(this.state.info, this.state.emailIds, Moment(temp).format('YYYY-MM-DD HH:mm'))
                .then(() => {
                    if (!this.props.commonStore.inProgress)
                        this.setState({ inProgress: false, showForm: false })
                })
        }

    }

    handleAddEmail = (option) => {
        let temp = this.state.emailIds.slice();
        temp.push(option)
        this.setState({ emailIds: temp })
    }

    handleDeleteEmail = (option, index) => {
        let temp = this.state.emailIds.slice();
        temp.splice(index, 1)
        this.setState({ emailIds: temp })
    }

    handleChange = (event, field, value) => {
        event.stopPropagation()
        const info = Object.assign({}, this.state.info, {
            [field]: value
        });
        this.setState({ info });
    }

    componentDidMount() {
        if (this.props.location.state && this.props.location.state.duration) {
            this.setState({ duration: this.props.location.state.duration, selectedDate: this.props.location.state.date })
        }
    }

    componentDidUpdate() {
        window.onpopstate = e => {
            this.props.history.push('/selectDate')
        }
    }


    render() {
        const { selectedDate, duration } = this.state;
        return (
            <div className='sc-container durationForm' >
                <div className='subHeading1 '>
                    <div className='vertCenter bold'>Confirmed</div>
                    <div className='desc'>You are scheduled for a demo with AmyGB</div>
                </div>
                <div className={'contact-formContainer'}>

                    <div className='desc confirmation '>A calendar invite has been sent to your email address<br /></div>
                </div>
                <script
                    dangerouslySetInnerHTML={{
                        __html: `
                        
_linkedin_partner_id = "3394058";
window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
window._linkedin_data_partner_ids.push(_linkedin_partner_id);
`
                    }}
                />
                 <script
                    dangerouslySetInnerHTML={{
                        __html: `
                        (function(l) {
if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
window.lintrk.q=[]}
var s = document.getElementsByTagName("script")[0];
var b = document.createElement("script");
b.type = "text/javascript";b.async = true;
b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
s.parentNode.insertBefore(b, s);})(window.lintrk);
`
                    }}
                />
                <noscript>
<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=3394058&fmt=gif" />
</noscript>
            </div>
        )
    }
}
Confirmation.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withRouter(Confirmation);
